document.addEventListener("DOMContentLoaded", function () {
  /*
  const heroSwiper = new Swiper(".hero-swiper .swiper", {
    loop: true,
    autoplay: false,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    effect: "slide",
    pagination: {
      el: ".hero-swiper .swiper-pagination",
      clickable: true,
    },
  });
  */
});
